import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unit',
})
export class UnitPipe implements PipeTransform {
  transform(value: any, unit?: any): unknown {
    if (unit) {
      return `${value} ${unit}`;
    } else {
      return `${value} KM`;
    }
  }
}
